import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { message } from 'antd';
import { DASHBOARD_QUERY_STUDENT } from '../queries';
import Crumbs from 'common/components/crumb';
import Info from './info';
import generatePath from '~settings/routing';

const StudentDetailHeader = ({ studentId }) => {
  const { t } = useTranslation();

  const { loading, data } = useQuery(DASHBOARD_QUERY_STUDENT, {
    variables: { id: studentId },
    fetchPolicy: 'no-cache',
    onError: err => {
      message.error(err.message?.toString());
    },
  });

  const crumbs = [
    {
      text: t('cms:cms.students.list.title'),
      link: generatePath('students.list'),
    },
    {
      text: t('cms:cms.students.detail.title'),
    },
  ];

  return (
    <div className="student-detail__header">
      <Crumbs items={crumbs} />
      <Info loading={loading} student={data?.listStudents?.edges?.[0]?.node || {}} />
    </div>
  );
};

export default StudentDetailHeader;
